import React from 'react';
import {ChartPie} from './ChartPie';
import {useIntl} from 'react-intl';
import {useSimpleDateRangeContext} from '../../SimpleDateRangeContext';
import Unit from '../../../_common/components/Unit';
import MultipleTooltip from '../../../_common/components/MultipleTooltip';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from '../../pages/styles.module.scss';

export const SimpleDateRange = () => {
  const intl = useIntl();
  const prefix = 'dashboard-page';

  const {data} = useSimpleDateRangeContext();
  const popularCities = data?.popularCities
    ? data?.popularCities.map(item => item.subCount)
    : [];
  const shumaStatuses = data?.statusTypes
    ? data?.statusTypes.map(item => item.subCount)
    : [];
  const banksRating = data?.banksRating
    ? data?.banksRating.map(item => item.subCount)
    : [];
  const usersRating = data?.usersRating
    ? data?.usersRating.map(item => item.subCount)
    : [];

  const popularCitiesLabels = data?.popularCities
    ? data?.popularCities.map(item => item.city_name)
    : [];
  const shumaStatusesLabels = data?.statusTypes
    ? data?.statusTypes.map(item => item.shuma_status_type_name_he)
    : [];
  const banksLabels = data?.popularCities
    ? data?.banksRating.map(item => item.bankName)
    : [];
  const usersLabels = data?.popularCities
    ? data?.usersRating.map(item => item.userName)
    : [];

  const commonProps = {
    icon: toAbsoluteUrl('/media/common/Pie_primary.svg'),
    customHeaderClassnames: 'justify-content-center'
  };

  return (
    <div className={styles.pieChartsContainer}>
      <Unit
        text={intl.formatMessage({
          id: `${prefix}-shuma-statuses-header`, defaultMessage: 'Segmentation of inspections in progress'
        })}
        {...commonProps}
      >
        <div className={styles.pieChart}><ChartPie data={shumaStatuses} labels={shumaStatusesLabels}/></div>
      </Unit>
      <Unit
        text={
          <div className={'d-flex align-items-center'}>
            {intl.formatMessage({id: `${prefix}-users-header`, defaultMessage: 'Users'})}
            <MultipleTooltip
              id={`chart-tooltip-1`}
              customIconClassName={'cursor-pointer mx-2 mb-1 position-static'}
              label={intl.formatMessage({
                id: `${prefix}-users-tooltip`, defaultMessage: 'Final reports, no past reports'
              })}
            />
          </div>
        }
        {...commonProps}
      >
        <div className={styles.pieChart}>
          <ChartPie data={usersRating} labels={usersLabels}/>
        </div>
      </Unit>
      <Unit
        text={intl.formatMessage({id: `${prefix}-cities-header`, defaultMessage: 'Common cities'})}
        {...commonProps}
      >
        <div className={styles.pieChart}><ChartPie data={popularCities} labels={popularCitiesLabels}/></div>
      </Unit>
      <Unit
        text={intl.formatMessage({id: `${prefix}-banks-header`, defaultMessage: 'Banks'})}
        {...commonProps}
      >
        <div className={styles.pieChart}><ChartPie data={banksRating} labels={banksLabels}/></div>
      </Unit>
    </div>
  );
};

